import contract from "@scaleip/nest-api/src/contracts";
import { initClient, tsRestFetchApi } from "@ts-rest/core";

import C from "@constants/constants";

export const tsRestClient = initClient(contract, {
  api: async (arguments_) => {
    return tsRestFetchApi({
      ...arguments_,
      headers: {
        ...arguments_.headers,
        authorization: `Bearer ${localStorage.getItem(C.AUTH_TOKEN_KEY)}`,
      },
    });
  },
  baseUrl: `${C.VITE_APP_NEST_SERVER}/v2`,
  credentials: "include",
  validateResponse: true,
});
